"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SearchBoxWrapper;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _reactSearchUi = require("@elastic/react-search-ui");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const SearchBoxContainer = /*#__PURE__*/(0, _react2.styled)(_reactSearchUi.SearchBox)({
  name: "SearchBoxContainer",
  class: "ep-s1lhzm0y"
});
function SearchBoxWrapper({
  placeholder,
  submitUrl,
  autocompleteSuggestions,
  autocompleteResults
}) {
  return /*#__PURE__*/_react.default.createElement(SearchBoxContainer, {
    inputProps: {
      placeholder
    },
    onSubmit: searchTerm => {
      if (submitUrl && typeof window !== 'undefined') {
        window.location.href = `${submitUrl}?q=${searchTerm}`;
      }
    },
    autocompleteSuggestions: autocompleteSuggestions,
    autocompleteResults: autocompleteResults,
    searchAsYouType: true,
    autocompleteMinimumCharacters: 3,
    debounceLength: 0
  });
}
SearchBoxWrapper.propTypes = {
  placeholder: _propTypes.default.string,
  submitUrl: _propTypes.default.string,
  autocompleteSuggestions: _propTypes.default.object,
  autocompleteResults: _propTypes.default.object
};